export enum FundClosedReasonDto {
  FundClosed = 'FUND_CLOSED',
  MissingMarketingPermission = 'MISSING_MARKETING_PERMISSION',
  UnsupportedCurrency = 'UNSUPPORTED_CURRENCY',
  UnsupportedFund = 'UNSUPPORTED_FUND',
}
